// extracted by mini-css-extract-plugin
export default {"sidebar":"c75e8d"};